
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function Industries() {
  const industries = [
    {
      title: 'Infrastructure & Government Projects',
      description: 'Supporting large-scale infrastructure development with reliable chemical solutions for bridges, highways, airports, and public facilities. Our expertise spans across critical government projects requiring the highest standards of quality and durability.',
      icon: 'ri-government-line',
      image: 'Large infrastructure construction project with modern bridges and highways under construction, government building development with heavy machinery and construction teams, public infrastructure with concrete structures and steel frameworks, professional engineering work with quality materials and systematic construction approach',
      features: [
        'Highway & Bridge Construction',
        'Airport Infrastructure Development',
        'Metro & Railway Projects',
        'Public Buildings & Facilities',
        'Water Treatment Plants',
        'Government Housing Projects',
        'Smart City Initiatives',
        'Port & Harbor Development'
      ],
      stats: {
        projects: '150+',
        experience: '25 Years',
        coverage: 'Pan-India'
      }
    },
    {
      title: 'Residential & Commercial Real Estate',
      description: 'Providing comprehensive chemical solutions for residential complexes, commercial buildings, and mixed-use developments. From luxury apartments to corporate towers, we ensure structural integrity and aesthetic excellence.',
      icon: 'ri-building-2-line',
      image: 'Modern residential and commercial building construction with high-rise apartment complexes and office towers under development, real estate construction site with cranes and scaffolding, contemporary architecture with glass facades and concrete structures, professional construction teams working on quality building projects',
      features: [
        'High-Rise Residential Towers',
        'Luxury Housing Complexes',
        'Shopping Malls & Retail',
        'Corporate Office Buildings',
        'Mixed-Use Developments',
        'Hospitality Projects',
        'Educational Institutions',
        'Healthcare Facilities'
      ],
      stats: {
        projects: '300+',
        experience: '20 Years',
        coverage: 'Major Cities'
      }
    },
    {
      title: 'Industrial Plants & Factories',
      description: 'Specialized chemical solutions for industrial facilities requiring high-performance flooring, waterproofing, and structural protection. Our solutions withstand extreme conditions and heavy industrial use.',
      icon: 'ri-factory-line',
      image: 'Industrial manufacturing plant construction with specialized flooring systems and chemical-resistant surfaces, factory facility with epoxy coating application and industrial equipment, manufacturing plant with heavy machinery and professional safety standards, industrial construction with advanced materials and protective systems',
      features: [
        'Manufacturing Plants',
        'Chemical Processing Units',
        'Food Processing Facilities',
        'Pharmaceutical Plants',
        'Automotive Manufacturing',
        'Textile Industries',
        'Power Generation Plants',
        'Oil & Gas Facilities'
      ],
      stats: {
        projects: '200+',
        experience: '22 Years',
        coverage: 'Industrial Hubs'
      }
    },
    {
      title: 'Public Works (Bridges, Dams, Tunnels)',
      description: 'Critical infrastructure projects requiring specialized chemical solutions for extreme conditions and long-term durability. Our expertise ensures structural integrity for generations.',
      icon: 'ri-road-map-line',
      image: 'Major public works construction including massive concrete dam construction with waterproofing systems, tunnel excavation and lining work with specialized chemical applications, bridge construction with structural strengthening and protective coatings, critical infrastructure development with engineering precision and quality materials',
      features: [
        'Dam Construction & Repair',
        'Tunnel Excavation & Lining',
        'Bridge Construction & Maintenance',
        'Port & Marine Infrastructure',
        'Underground Metro Systems',
        'Flyover & Expressways',
        'Water Distribution Systems',
        'Sewage Treatment Plants'
      ],
      stats: {
        projects: '100+',
        experience: '25 Years',
        coverage: 'National Level'
      }
    },
    {
      title: 'RMC Plants & Aggregators',
      description: 'Continuous supply of admixtures and chemical solutions for ready-mix concrete plants and aggregate suppliers. Ensuring consistent quality and performance optimization across all batches.',
      icon: 'ri-truck-line',
      image: 'Ready-mix concrete plant operations with automated chemical dosing systems and concrete mixing trucks, modern RMC facility with conveyor systems and storage silos, concrete production equipment with quality control processes and chemical admixture integration, industrial batching plant with professional operations and quality assurance',
      features: [
        'Concrete Admixtures Supply',
        'Quality Enhancement Solutions',
        'Batch Consistency Programs',
        'Performance Optimization',
        'Technical Support Services',
        'Equipment Calibration',
        'Process Automation',
        'Quality Control Systems'
      ],
      stats: {
        partners: '50+',
        experience: '18 Years',
        coverage: 'Regional Network'
      }
    },
    {
      title: 'Specialty Applicator Firms',
      description: 'Supporting specialized contractors with technical expertise, training, and high-performance chemical solutions. Empowering professionals with cutting-edge technologies and comprehensive support.',
      icon: 'ri-tools-fill',
      image: 'Specialty construction contractors applying advanced waterproofing and protective coating systems, professional applicator teams using specialized equipment and safety gear, technical construction work with precision application methods and quality control, expert contractors working on structural repair and rehabilitation projects',
      features: [
        'Waterproofing Contractors',
        'Flooring Specialists',
        'Repair & Rehabilitation Experts',
        'Protective Coating Applicators',
        'Structural Strengthening Teams',
        'Injection Grouting Specialists',
        'Corrosion Protection Experts',
        'Surface Preparation Contractors'
      ],
      stats: {
        partners: '200+',
        experience: '20 Years',
        coverage: 'Nationwide'
      }
    }
  ];

  const successStories = [
    {
      title: 'Delhi Metro Phase IV Extension',
      description: 'Supplied comprehensive waterproofing and structural protection solutions for critical underground infrastructure, ensuring long-term durability against groundwater and environmental challenges.',
      category: 'Infrastructure',
      location: 'New Delhi',
      value: '₹50 Crores',
      duration: '24 Months',
      image: 'Delhi metro construction project with advanced waterproofing systems being applied in underground metro station, tunnel construction with specialized chemical applications, urban transit infrastructure development with professional engineering teams and quality control processes'
    },
    {
      title: 'Rajasthan State Highway Bridge',
      description: 'Delivered specialized admixtures and grouting systems for major bridge construction in challenging desert conditions, ensuring structural integrity and weather resistance.',
      category: 'Public Works',
      location: 'Rajasthan',
      value: '₹35 Crores',
      duration: '18 Months',
      image: 'Bridge construction project in Rajasthan with concrete admixtures and structural grouting systems, major infrastructure bridge development in desert conditions, concrete strengthening and protective systems application with professional construction teams'
    },
    {
      title: 'Pharmaceutical Clean Room Facility',
      description: 'Provided specialized epoxy flooring and contamination control solutions for pharmaceutical manufacturing facility meeting international standards.',
      category: 'Industrial',
      location: 'Pune',
      value: '₹25 Crores',
      duration: '12 Months',
      image: 'Clean room facility construction with specialized epoxy flooring systems, pharmaceutical manufacturing plant with sterile environment flooring installation, industrial clean room construction with contamination control systems and professional safety standards'
    },
    {
      title: 'Smart City Housing Project',
      description: 'Complete chemical solutions for large-scale residential development including waterproofing, flooring, and structural protection systems.',
      category: 'Residential',
      location: 'Ahmedabad',
      value: '₹40 Crores',
      duration: '30 Months',
      image: 'Smart city residential development with modern apartment complexes under construction, large-scale housing project with comprehensive chemical solutions, contemporary residential towers with quality construction materials and professional building techniques'
    },
    {
      title: 'Industrial Manufacturing Hub',
      description: 'Specialized flooring and protective coating solutions for automotive manufacturing facility requiring chemical resistance and durability.',
      category: 'Industrial',
      location: 'Chennai',
      value: '₹30 Crores',
      duration: '15 Months',
      image: 'Automotive manufacturing facility construction with specialized industrial flooring, chemical-resistant coating application in manufacturing plant, industrial facility with heavy-duty flooring systems and protective surface treatments'
    },
    {
      title: 'Airport Terminal Expansion',
      description: 'Comprehensive chemical solutions for airport infrastructure including waterproofing, flooring, and structural strengthening systems.',
      category: 'Infrastructure',
      location: 'Bangalore',
      value: '₹60 Crores',
      duration: '36 Months',
      image: 'Airport terminal construction with comprehensive chemical solutions, modern airport infrastructure development with waterproofing and flooring systems, aviation facility construction with professional engineering and quality materials'
    }
  ];

  const clientTypes = [
    {
      title: 'Government Bodies',
      description: 'Central and state government departments, public sector undertakings, and municipal corporations',
      icon: 'ri-government-line',
      color: '#7E887E',
      clients: ['Ministry of Road Transport', 'Indian Railways', 'Airport Authority of India', 'State PWDs', 'Municipal Corporations']
    },
    {
      title: 'Developers & Builders',
      description: 'Leading real estate developers, construction companies, and project management consultants',
      icon: 'ri-building-line',
      color: '#2563EB',
      clients: ['DLF Limited', 'Godrej Properties', 'Prestige Group', 'Brigade Group', 'Sobha Limited']
    },
    {
      title: 'RMC Plants',
      description: 'Ready-mix concrete manufacturers, aggregate suppliers, and concrete technology companies',
      icon: 'ri-truck-line',
      color: '#7C3AED',
      clients: ['UltraTech Cement', 'ACC Limited', 'Ambuja Cement', 'RMC Readymix', 'Concrete Plus']
    },
    {
      title: 'Specialty Contractors',
      description: 'Specialized applicators, waterproofing contractors, and construction service providers',
      icon: 'ri-tools-line',
      color: '#EA580C',
      clients: ['Waterproofing Specialists', 'Flooring Contractors', 'Repair Specialists', 'Coating Applicators']
    },
    {
      title: 'Industrial Clients',
      description: 'Manufacturing companies, processing plants, and industrial facility developers',
      icon: 'ri-factory-line',
      color: '#DC2626',
      clients: ['Tata Steel', 'Reliance Industries', 'Mahindra Group', 'L&T Construction', 'BHEL']
    },
    {
      title: 'Consultants',
      description: 'Engineering consultants, architectural firms, and project management companies',
      icon: 'ri-user-line',
      color: '#059669',
      clients: ['L&T Technology', 'Engineers India', 'WAPCOS', 'RITES Limited', 'NBCC India']
    }
  ];

  const clientReviews = [
    {
      name: "Rajesh Kumar",
      position: "Project Director",
      company: "Delhi Metro Rail Corporation",
      review: "Lavin Enterprises has been our trusted partner for multiple metro projects. Their technical expertise in waterproofing solutions and timely delivery has been exceptional across all infrastructure challenges.",
      rating: 5,
      project: "Delhi Metro Phase IV",
      image: "Professional Indian project director at metro construction site, experienced infrastructure professional with safety helmet and engineering plans, modern metro tunnel construction background with technical equipment"
    },
    {
      name: "Priya Mehta",
      position: "Chief Engineer",
      company: "Godrej Properties",
      review: "Working with Lavin Enterprises for our residential projects has been outstanding. Their comprehensive chemical solutions and technical guidance have consistently delivered superior quality results.",
      rating: 5,
      project: "Luxury Housing Complex",
      image: "Professional Indian female chief engineer at residential construction site, confident engineering professional with safety gear and construction plans, modern apartment building development background"
    },
    {
      name: "Amit Sharma",
      position: "Operations Manager",
      company: "Tata Steel Construction",
      review: "The industrial flooring solutions provided by Lavin Enterprises exceeded our expectations. Their chemical-resistant coatings have proven highly durable under extreme industrial conditions.",
      rating: 5,
      project: "Industrial Manufacturing Plant",
      image: "Professional Indian operations manager at industrial facility, experienced manufacturing professional with safety equipment and quality control tools, modern steel plant construction background"
    },
    {
      name: "Suresh Patel",
      position: "Site Engineer",
      company: "L&T Construction",
      review: "Lavin's technical support team is outstanding. They provided comprehensive on-ground assistance throughout our bridge construction project, ensuring perfect application and long-term durability.",
      rating: 5,
      project: "Highway Bridge Construction",
      image: "Professional Indian site engineer at bridge construction project, experienced civil engineer with construction drawings and safety gear, large bridge infrastructure background with construction machinery"
    },
    {
      name: "Dr. Kavita Singh",
      position: "Quality Manager",
      company: "UltraTech RMC",
      review: "As an RMC plant, we rely on consistent quality admixtures. Lavin Enterprises has been our reliable partner, providing superior concrete admixtures that significantly enhance our product performance.",
      rating: 5,
      project: "Ready Mix Concrete Supply",
      image: "Professional Indian female quality manager at concrete plant facility, experienced quality control professional with testing equipment, modern RMC plant background with concrete mixing operations"
    },
    {
      name: "Vikram Joshi",
      position: "Project Head",
      company: "Airport Authority of India",
      review: "For our airport terminal expansion, Lavin Enterprises delivered comprehensive chemical solutions on time and within budget. Their expertise in large-scale infrastructure projects is truly commendable.",
      rating: 5,
      project: "Airport Terminal Expansion",
      image: "Professional Indian project head at airport construction site, confident aviation infrastructure professional with safety vest and project documentation, modern airport terminal construction background"
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="pt-20 relative min-h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(69, 82, 74, 0.8), rgba(69, 82, 74, 0.6)), url('https://readdy.ai/api/search-image?query=Diverse%20construction%20industry%20panorama%20showing%20infrastructure%20projects%2C%20residential%20buildings%2C%20industrial%20facilities%2C%20bridges%20and%20public%20works%2C%20comprehensive%20construction%20landscape%20with%20various%20building%20types%20and%20engineering%20projects%2C%20professional%20construction%20industry%20overview%20with%20modern%20architecture%20and%20infrastructure%20development&width=1920&height=1080&seq=industries-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Industries &amp; Clients We Serve
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
              Trusted partner across diverse sectors with specialized solutions for every industry need
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
                Explore Solutions
              </button>
              <button 
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
              >
                View Projects
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Overview */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#45524A' }}>
                Comprehensive Industry Expertise
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                With over 25 years of experience, we serve diverse sectors with specialized chemical solutions, 
                technical expertise, and unwavering commitment to quality and innovation.
              </p>
            </div>

            <div className="space-y-16">
              {industries.map((industry, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden">
                  <div className="grid lg:grid-cols-2 gap-0">
                    <div className="p-8 lg:p-12">
                      <div className="flex items-center mb-6">
                        <div className="w-20 h-20 rounded-xl flex items-center justify-center mr-6" style={{ backgroundColor: 'rgba(69, 82, 74, 0.1)' }}>
                          <i className={`${industry.icon} text-4xl`} style={{ color: '#45524A' }}></i>
                        </div>
                        <div>
                          <h3 className="text-2xl lg:text-3xl font-bold mb-2" style={{ color: '#45524A' }}>{industry.title}</h3>
                          <div className="flex gap-4 text-sm text-gray-500">
                            <span>{industry.stats.projects || industry.stats.partners} {industry.stats.projects ? 'Projects' : 'Partners'}</span>
                            <span>{industry.stats.experience} Experience</span>
                          </div>
                        </div>
                      </div>
                      <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                        {industry.description}
                      </p>
                      <div className="mb-8">
                        <h4 className="text-lg font-semibold text-gray-800 mb-6">Key Applications &amp; Services:</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          {industry.features.map((feature, featureIndex) => (
                            <div key={featureIndex} className="flex items-center space-x-3">
                              <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: '#45524A' }}></div>
                              <span className="text-gray-700 text-sm">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-4">
                        <button className="text-white px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap font-semibold" style={{ backgroundColor: '#45524A' }}>
                          Get Solutions
                        </button>
                        <button className="border-2 text-gray-700 px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap font-semibold hover:bg-gray-50" style={{ borderColor: '#45524A' }}>
                          View Case Studies
                        </button>
                      </div>
                    </div>
                    <div className="relative min-h-[400px] lg:min-h-[600px]">
                      <img 
                        src={(() => {
                          switch(index) {
                            case 0: return "https://readdy.ai/api/search-image?query=Modern%20highway%20bridge%20construction%20with%20concrete%20structures%20and%20government%20infrastructure%20projects%2C%20construction%20workers%20applying%20chemical%20solutions%20to%20large-scale%20civil%20engineering%20projects%2C%20professional%20construction%20site%20with%20cranes%20and%20heavy%20machinery%2C%20quality%20control%20and%20systematic%20construction%20approach&width=800&height=600&seq=infrastructure-govt-updated&orientation=landscape";
                            case 1: return "https://readdy.ai/api/search-image?query=Luxury%20high-rise%20towers%20and%20commercial%20buildings%20under%20construction%2C%20contemporary%20real%20estate%20developments%20with%20glass%20facades%20and%20modern%20architecture%2C%20urban%20skyline%20with%20mixed-use%20developments%2C%20professional%20construction%20teams%20working%20on%20quality%20building%20projects&width=800&height=600&seq=residential-commercial-updated&orientation=landscape";
                            case 2: return "https://readdy.ai/api/search-image?query=Large%20manufacturing%20plants%20with%20heavy%20machinery%20and%20chemical%20processing%20equipment%2C%20industrial%20facilities%20with%20workers%20applying%20industrial%20chemical%20solutions%20with%20safety%20protocols%2C%20modern%20factory%20construction%20with%20specialized%20equipment%20and%20professional%20safety%20standards&width=800&height=600&seq=industrial-plants-updated&orientation=landscape";
                            case 3: return "https://readdy.ai/api/search-image?query=Municipal%20road%20construction%20and%20public%20infrastructure%20development%2C%20city%20development%20with%20drainage%20systems%20and%20public%20buildings%2C%20community%20facilities%20and%20parks%20under%20construction%2C%20public%20works%20projects%20with%20engineering%20precision%20and%20quality%20materials&width=800&height=600&seq=public-works-updated&orientation=landscape";
                            case 4: return "https://readdy.ai/api/search-image?query=Ready%20Mix%20Concrete%20plants%20with%20mixing%20trucks%20and%20industrial%20concrete%20production%20facilities%2C%20workers%20adding%20chemical%20admixtures%20to%20concrete%20mixers%2C%20modern%20batching%20plant%20operations%20with%20quality%20control%20processes%20and%20professional%20operations&width=800&height=600&seq=rmc-plants-updated&orientation=landscape";
                            case 5: return "https://readdy.ai/api/search-image?query=Professional%20contractors%20applying%20waterproofing%20and%20protective%20coatings%2C%20skilled%20workers%20using%20specialized%20chemical%20application%20equipment%2C%20technical%20experts%20demonstrating%20proper%20application%20techniques%20with%20precision%20methods%20and%20safety%20gear&width=800&height=600&seq=specialty-applicators-updated&orientation=landscape";
                            default: return industry.image;
                          }
                        })()}
                        alt={industry.title}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4">
                          <div className="grid grid-cols-3 gap-4 text-center">
                            <div>
                              <div className="text-2xl font-bold" style={{ color: '#45524A' }}>{industry.stats.projects || industry.stats.partners}</div>
                              <div className="text-sm text-gray-600">{industry.stats.projects ? 'Projects' : 'Partners'}</div>
                            </div>
                            <div>
                              <div className="text-2xl font-bold" style={{ color: '#45524A' }}>{industry.stats.experience}</div>
                              <div className="text-sm text-gray-600">Experience</div>
                            </div>
                            <div>
                              <div className="text-2xl font-bold" style={{ color: '#45524A' }}>{industry.stats.coverage}</div>
                              <div className="text-sm text-gray-600">Coverage</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#45524A' }}>
                Success Stories &amp; Major Projects
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                Showcasing our expertise through landmark projects that demonstrate our commitment to excellence, 
                innovation, and reliable delivery across diverse industry sectors.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {successStories.map((story, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100">
                  <div className="relative">
                    <img 
                      src={(() => {
                        switch(index) {
                          case 0: return "https://readdy.ai/api/search-image?query=Delhi%20Metro%20underground%20station%20construction%20with%20waterproofing%20systems%2C%20modern%20subway%20tunnel%20infrastructure%2C%20workers%20applying%20chemical%20protection%20solutions%20to%20concrete%20walls%2C%20advanced%20metro%20rail%20construction%20with%20technical%20equipment&width=500&height=300&seq=delhi-metro-project&orientation=landscape";
                          case 1: return "https://readdy.ai/api/search-image?query=Large%20highway%20bridge%20construction%20in%20Rajasthan%20desert%20landscape%2C%20concrete%20bridge%20structure%20with%20construction%20cranes%2C%20workers%20applying%20grouting%20systems%20and%20admixtures%2C%20state%20highway%20infrastructure%20project%20with%20engineering%20equipment&width=500&height=300&seq=rajasthan-bridge&orientation=landscape";
                          case 2: return "https://readdy.ai/api/search-image?query=Modern%20pharmaceutical%20clean%20room%20facility%20construction%2C%20sterile%20manufacturing%20environment%20with%20epoxy%20flooring%20installation%2C%20workers%20in%20protective%20suits%20applying%20specialized%20chemical%20coatings%2C%20pharmaceutical%20industry%20infrastructure%20with%20quality%20control%20systems&width=500&height=300&seq=pharma-facility&orientation=landscape";
                          case 3: return "https://readdy.ai/api/search-image?query=Smart%20city%20residential%20housing%20development%20construction%2C%20modern%20apartment%20buildings%20under%20construction%2C%20workers%20applying%20waterproofing%20and%20structural%20protection%20systems%2C%20large-scale%20housing%20project%20with%20construction%20machinery%20and%20safety%20protocols&width=500&height=300&seq=smart-housing&orientation=landscape";
                          case 4: return "https://readdy.ai/api/search-image?query=Industrial%20automotive%20manufacturing%20plant%20construction%2C%20large%20factory%20building%20with%20specialized%20flooring%20installation%2C%20workers%20applying%20chemical%20resistant%20coatings%20and%20protective%20systems%2C%20modern%20manufacturing%20facility%20with%20heavy%20machinery&width=500&height=300&seq=manufacturing-hub&orientation=landscape";
                          case 5: return "https://readdy.ai/api/search-image?query=Airport%20terminal%20expansion%20construction%20project%2C%20modern%20aviation%20infrastructure%20with%20glass%20and%20steel%20architecture%2C%20workers%20applying%20waterproofing%20and%20structural%20strengthening%20systems%2C%20large-scale%20airport%20construction%20with%20cranes%20and%20technical%20equipment&width=500&height=300&seq=airport-terminal&orientation=landscape";
                          default: return story.image;
                        }
                      })()}
                      alt={story.title}
                      className="w-full h-56 object-cover object-top"
                    />
                    <div className="absolute top-4 left-4">
                      <span 
                        className="text-white px-4 py-2 rounded-full text-sm font-semibold"
                        style={{ backgroundColor: '#45524A' }}
                      >
                        {story.category}
                      </span>
                    </div>
                    <div className="absolute top-4 right-4">
                      <span className="bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                        {story.location}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{story.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-4">{story.description}</p>
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <div className="text-sm text-gray-5">Project Value</div>
                        <div className="font-semibold" style={{ color: '#45524A' }}>{story.value}</div>
                      </div>
                      <div>
                        <div className="text-sm text-gray-5">Duration</div>
                        <div className="font-semibold" style={{ color: '#45524A' }}>{story.duration}</div>
                      </div>
                    </div>
                    <button 
                      className="w-full text-center py-2 rounded-lg border-2 font-semibold transition-colors cursor-pointer hover:bg-gray-50"
                      style={{ borderColor: '#45524A', color: '#45524A' }}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Client Reviews Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#45524A' }}>
                Industry Leaders Trust Us
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                Hear from our valued clients across different industries about their experience with our 
                specialized solutions and professional service delivery.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {clientReviews.map((review, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="flex items-center mb-6">
                    <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                      <img 
                        src={`https://readdy.ai/api/search-image?query=$%7Breview.image%7D&width=150&height=150&seq=industries-client-${index}&orientation=squarish`}
                        alt={review.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-800">{review.name}</h3>
                      <p className="text-sm text-gray-600">{review.position}</p>
                      <p className="text-sm font-medium" style={{ color: '#45524A' }}>{review.company}</p>
                    </div>
                  </div>

                  <div className="flex mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                    ))}
                  </div>

                  <p className="text-gray-700 leading-relaxed mb-4 italic">
                    "{review.review}"
                  </p>

                  <div className="border-t pt-4">
                    <div className="flex items-center text-sm text-gray-500">
                      <i className="ri-building-line mr-2"></i>
                      <span>{review.project}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Industry Trust Indicators */}
            <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
              <div className="grid md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>6</div>
                  <div className="text-gray-600">Major Industries</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>500+</div>
                  <div className="text-gray-600">Completed Projects</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>200+</div>
                  <div className="text-gray-600">Active Clients</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>99.8%</div>
                  <div className="text-gray-600">Client Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Network */}
      <section className="py-20" style={{ background: 'linear-gradient(to bottom, rgba(69, 82, 74, 0.05), rgba(69, 82, 74, 0.1))' }}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#45524A' }}>
                Our Prestigious Client Network
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                Trusted by leading organizations across industries, we maintain long-term partnerships 
                built on reliability, quality, and exceptional service delivery.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {clientTypes.map((client, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="text-center mb-6">
                    <div 
                      className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4"
                      style={{ backgroundColor: `${client.color}15` }}
                    >
                      <i className={`${client.icon} text-4xl`} style={{ color: client.color }}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{client.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{client.description}</p>
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Key Clients:</h4>
                    <div className="space-y-2">
                      {client.clients.map((clientName, clientIndex) => (
                        <div key={clientIndex} className="flex items-center space-x-2">
                          <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: client.color }}></div>
                          <span className="text-sm text-gray-600">{clientName}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Partnership Stats */}
            <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
              <h3 className="text-3xl font-bold mb-8 text-center" style={{ color: '#45524A' }}>
                Partnership Excellence
              </h3>
              <div className="grid md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>500+</div>
                  <div className="text-gray-600">Completed Projects</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>200+</div>
                  <div className="text-gray-600">Active Clients</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>25+</div>
                  <div className="text-gray-600">Years Experience</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>99.8%</div>
                  <div className="text-gray-600">Client Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section 
        className="py-20 relative"
        style={{
          backgroundImage: `linear-gradient(rgba(69, 82, 74, 0.9), rgba(69, 82, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Professional%20construction%20team%20handshake%20and%20partnership%20meeting%2C%20business%20collaboration%20in%20construction%20industry%2C%20engineering%20professionals%20discussing%20project%20plans%2C%20construction%20industry%20partnership%20and%20teamwork%20with%20modern%20office%20and%20construction%20site%20background&width=1920&height=600&seq=industries-cta&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Partner with Industry Leaders?
            </h2>
            <p className="text-xl mb-8 opacity-90 leading-relaxed">
              Join our network of successful clients and experience the difference that quality, 
              expertise, and reliable service can make for your next project.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
                Start Your Project
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
                Schedule Consultation
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
